import { render, staticRenderFns } from "./PatDetails.vue?vue&type=template&id=44fc98ea&scoped=true"
import script from "./PatDetails.vue?vue&type=script&lang=js"
export * from "./PatDetails.vue?vue&type=script&lang=js"
import style0 from "./PatDetails.vue?vue&type=style&index=0&id=44fc98ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fc98ea",
  null
  
)

export default component.exports